/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronRightPipe = createReactComponent(
  "chevron-right-pipe",
  "IconChevronRightPipe",
  [
    ["path", { d: "M6 6l6 6l-6 6", key: "svg-0" }],
    ["path", { d: "M17 5v13", key: "svg-1" }]
  ]
);

export { IconChevronRightPipe as default };
//# sourceMappingURL=IconChevronRightPipe.js.map
